
import { Options, Vue } from 'vue-class-component';

interface NavItem {
  Title: string;
  Icon: string;
  Path: string;
}

@Options({
})
export default class Calendar extends Vue {
  private navItems: NavItem[] = [
    {
      Title: 'Home',
      Icon: 'schedule',
      Path: '/'
    },
    {
      Title: 'About',
      Icon: 'info-circle',
      Path: '/about'
    }
  ];
}
